import { useQuery } from '@tanstack/react-query'

import EnvironmentProvider, { useEnvironment } from './EnvironmentProvider'
import { IRequestProvider } from './RequestProvider'

type TCurrents<T = unknown> = Record<string, T>
export interface ICurrentProvider<T = unknown> extends IRequestProvider<T> {
  currents: TCurrents<T>
  oneTime?: boolean
}

const CurrentProvider = <T extends object>({
  apiId = 'default',
  currentKey = 'current',
  currentPath = '/_current.json',
  oneTime = false,
  ...props
}) => {
  const { currents, requests } = useEnvironment<ICurrentProvider<T>>()

  const { data: current } = useQuery(
    [currentKey, 'current'],
    () =>
      requests[apiId]({
        method: 'GET',
        url: currentPath,
      }),
    {
      refetchInterval: oneTime ? false : 1000 * 3,
      staleTime: 0,
    }
  )

  if (!requests[apiId]) return null

  const newCurrents = {
    ...currents,
    [currentKey]: current,
  }

  return (
    <EnvironmentProvider
      env={{ currents: newCurrents }}
      {...props}
    />
  )
}

export default CurrentProvider
